const EVENT_NAME = "ForecastExpanded"

function dispatchGlobalEvent(column) {
  document.dispatchEvent(
    new CustomEvent(EVENT_NAME, {
      detail: column,
    }),
  )
}

export default dispatchGlobalEvent
